import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createMemoStyles, safeRest, defaultFonts, deprecate, uniqueId } from '@wds/utils';
import { useTheme } from 'react-jss';
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var useStyles = createMemoStyles(function (theme) {
  var type = theme.type,
    spacing = theme.spacing,
    palette = theme.palette;
  return {
    wrenchLabel: function wrenchLabel(_ref) {
      var muted = _ref.muted,
        plain = _ref.plain;
      return _objectSpread$1(_objectSpread$1({
        display: 'block',
        color: palette.text.dark,
        fontFamily: type.fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        boxSizing: 'border-box',
        fontSize: type.fontSize.bodySm,
        padding: 0,
        margin: [0, 0, spacing[2]],
        fontWeight: type.fontWeight.medium
      }, plain && {
        fontWeight: type.fontWeight.regular,
        fontSize: type.fontSize.body
      }), muted && {
        color: palette.text.darkMuted,
        fontWeight: type.fontWeight.regular
      });
    }
  };
});
var useStyles$1 = useStyles;
var _excluded$2 = ["children", "htmlFor", "muted", "plain"];
var Label = function Label(_ref) {
  var children = _ref.children,
    htmlFor = _ref.htmlFor,
    muted = _ref.muted,
    plain = _ref.plain,
    rest = _objectWithoutProperties(_ref, _excluded$2);
  var theme = useTheme();
  var _useStyles = useStyles$1({
      theme: theme,
      muted: muted,
      plain: plain
    }),
    wrenchLabel = _useStyles.wrenchLabel;
  return /*#__PURE__*/React.createElement("label", Object.assign({
    className: wrenchLabel,
    htmlFor: htmlFor
  }, safeRest(rest)), children);
};
Label.displayName = "Label";
Label.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool
};
Label.defaultProps = {
  muted: false,
  plain: false
};
var Label$1 = Label;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var useStylesInput = createMemoStyles(function (theme) {
  var radius = theme.radius,
    palette = theme.palette,
    shadow = theme.shadow,
    spacing = theme.spacing,
    border = theme.border;
  var iconColors = {
    default: palette.text.dark,
    success: palette.success.main,
    warning: palette.warning.main,
    error: palette.error.main
  };
  return {
    wrenchInputGroup: function wrenchInputGroup(_ref) {
      var color = _ref.color,
        stretched = _ref.stretched,
        disabled = _ref.disabled;
      return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        border: border.main,
        background: palette.background.light,
        borderRadius: radius.small,
        width: stretched && '100%',
        pointerEvents: disabled && 'none',
        opacity: disabled && '0.4',
        borderColor: color === 'default' ? palette.border.main : iconColors[color],
        '&:hover': {
          borderColor: color === 'default' ? palette.border.hover : iconColors[color],
          boxShadow: shadow.sky,
          transition: ['border-color 100ms', 'box-shawdow 100ms']
        },
        '&:focus': {
          borderColor: color === 'default' ? palette.border.active : iconColors[color],
          transition: ['border-color', '100ms']
        },
        '& > input': {
          color: color === 'default' ? palette.text.dark : iconColors[color],
          border: 'none',
          flexGrow: 1,
          width: stretched && '100%',
          '&:hover': {
            boxShadow: 'none'
          }
        },
        '&:empty': {
          border: 0,
          clip: 'rect(1px, 1px, 1px, 1px)',
          height: '1px',
          margin: '-1px',
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          width: '1px'
        }
      };
    },
    wrenchInputGroupAddon: _objectSpread(_objectSpread({
      whiteSpace: 'nowrap'
    }, defaultFonts(theme)), {}, {
      '&:first-child': {
        paddingLeft: spacing[1],
        '& > svg': {
          marginLeft: spacing[2],
          fill: function fill(_ref2) {
            var color = _ref2.color;
            return color === 'default' ? palette.text.dark : iconColors[color];
          },
          color: function color(_ref3) {
            var _color = _ref3.color;
            return _color === 'default' ? palette.text.dark : iconColors[_color];
          }
        }
      },
      '&:last-child': {
        paddingRight: spacing[1],
        '& > svg': {
          marginRight: spacing[2],
          fill: function fill(_ref4) {
            var color = _ref4.color;
            return color === 'default' ? palette.text.dark : iconColors[color];
          },
          color: function color(_ref5) {
            var _color2 = _ref5.color;
            return _color2 === 'default' ? palette.text.dark : iconColors[_color2];
          }
        }
      }
    })
  };
});
var _excluded$1 = ["children", "id", "label", "stretched", "disabled", "color"];
var COLOR_OPTIONS = ['default', 'success', 'warning', 'error'];
var InputGroup = function InputGroup(_ref) {
  var children = _ref.children,
    id = _ref.id,
    label = _ref.label,
    stretched = _ref.stretched,
    disabled = _ref.disabled,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  deprecate({
    color: color
  }, 'color', 'warning', 'InputGroup');
  var theme = useTheme();
  var inputID = useMemo(function () {
    return id || uniqueId('input');
  }, [id]);
  var _useStyles = useStylesInput({
      color: color,
      stretched: stretched,
      disabled: disabled,
      theme: theme
    }),
    wrenchInputGroup = _useStyles.wrenchInputGroup;
  return /*#__PURE__*/React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement(Label$1, {
    htmlFor: inputID
  }, label) : null, /*#__PURE__*/React.createElement("div", Object.assign({
    className: wrenchInputGroup
  }, safeRest(rest)), children));
};
InputGroup.propTypes = {
  /**
   * Composed of Input and InputGroupAddon components
   */
  children: PropTypes.node.isRequired,
  /**
   * Unique identifier for InputGroup
   */
  id: PropTypes.string,
  /**
   * Add label for input group
   */
  label: PropTypes.node,
  /**
   * Extends input group to fit the full width of parent container
   */
  stretched: PropTypes.bool,
  /**
   * If true, will disable the input group
   */
  disabled: PropTypes.bool,
  /**
   * Color variants for Input Group
   */
  color: PropTypes.oneOf(COLOR_OPTIONS)
};
InputGroup.defaultProps = {
  id: undefined,
  label: undefined,
  stretched: false,
  disabled: false,
  color: 'default'
};
var _excluded = ["children", "color"];
var InputGroupAddon = function InputGroupAddon(_ref) {
  var children = _ref.children,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _useStyles = useStylesInput({
      theme: theme,
      color: color
    }),
    wrenchInputGroupAddon = _useStyles.wrenchInputGroupAddon;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: wrenchInputGroupAddon
  }, safeRest(rest)), children);
};
InputGroupAddon.displayName = "InputGroupAddon";
InputGroupAddon.propTypes = {
  color: PropTypes.oneOf(COLOR_OPTIONS),
  children: PropTypes.node.isRequired
};
InputGroupAddon.defaultProps = {
  color: 'default'
};
export { InputGroup, InputGroupAddon };